module.exports = __webpack_public_path__ + "media/customizations/breezehome/logo-d34d0cff2dcb786e17ee2e572a90ba20.png";